import authHeader from "../../../../authentication/authservices/auth-header";
import apiClient from "../../../../http-common";

export const savePROForm = (postObj) => {
  return apiClient.post(`/pro/save`, postObj, {
    headers: authHeader(),
  });
};

export const getPROPFormData = (patientId) => {
  return apiClient.get(`/pro/getProForm/${patientId}`, {
    headers: authHeader(),
  });
};
